module.exports = __webpack_public_path__ + "static/media/013.f6f720f1.jpg";